import './PracticeCard.scss'
import { Card } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import parse from 'html-react-parser'

import { navigateTo } from '../../common/navigation'
import { ROUTE_MEMBERSHIP } from 'components/common/helpers/Paths'
import { buildRequestURL } from 'components/common/api'
import Bookmark from 'components/bookmark/Bookmark'
import { practices } from 'components/common/api/constants'

// Get list of practices that have intros

const routesWithIntros = practices
  .map(practice => practice.hasIntro && practice.path)
  .filter(Boolean)

export default function PracticeCard({
  title,
  practiceId,
  baseUrl,
  isLocked,
  returnPath,
  lockedReturnPath = null,
  style = null,
  practiceType = null
}) {
  const history = useHistory()

  /**
   * Simple click handler
   */
  const handleClick = () => {
    const hasIntro = routesWithIntros.includes(baseUrl)

    let url = baseUrl + (hasIntro ? '/intro/' : '/') + practiceId

    // Is this practice item locked?
    if (isLocked)
      url = buildRequestURL(ROUTE_MEMBERSHIP, {
        returnPath: lockedReturnPath ?? baseUrl
      })
    if (returnPath) url = buildRequestURL(url, { returnPath })

    navigateTo(url, history)
  }

  // Return early if we don't have all the required props
  if (!title || !practiceId || !baseUrl) return null

  return (
    <Card className='practice-card' style={style}>
      <Card.Body className='practice-card-body' onClick={handleClick}>
        <Card.Title className='practice-title'>
          {isLocked ? (
            <i className='bi bi-lock' />
          ) : (
            <Bookmark
              color='text-black'
              category={practiceType}
              categoryObjectId={practiceId}
            />
          )}
          {parse(title)}
        </Card.Title>
      </Card.Body>
    </Card>
  )
}
